import { render, staticRenderFns } from "./ConsultantRegister.vue?vue&type=template&id=0c061446&scoped=true&"
import script from "./ConsultantRegister.vue?vue&type=script&lang=js&"
export * from "./ConsultantRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c061446",
  null
  
)

export default component.exports